import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Coins, TrendingDown, Users, Activity, ArrowUpRight } from 'lucide-react';
import Sparkline from './credits/Sparkline';

export default function GCKpiCards({ stats, sparkSeries }) {
  if (!stats) return null;
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <Card className="kpi-rise kpi-rise-0 relative overflow-hidden border-0 shadow-lg group hover:shadow-xl transition-all">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-indigo-700" />
            <CardContent className="relative p-5">
              <div className="flex items-center justify-between mb-3">
                <div className="p-2 rounded-lg bg-white/20 backdrop-blur">
                  <Coins className="w-5 h-5 text-white" />
                </div>
                <div className="flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-400/30 backdrop-blur text-xs font-semibold text-white">
                  <ArrowUpRight className="w-3 h-3" />
                  +12%
                </div>
              </div>
              <div className="text-3xl font-bold text-white tabular-nums">
                {stats.total_credits_vendus?.toLocaleString('fr-FR') || 0}
              </div>
              <div className="text-xs text-blue-100 mt-1">Crédits Vendus · Total historique</div>
              <div className="mt-3 text-white/85" title="Évolution sur 7 jours">
                <Sparkline data={sparkSeries?.credits_vendus || []} color="#ffffff" width={260} height={34} ariaLabel="Crédits vendus sur 7 jours" />
              </div>
            </CardContent>
          </Card>

          <Card className="kpi-rise kpi-rise-1 relative overflow-hidden border-0 shadow-lg group hover:shadow-xl transition-all">
            <div className="absolute inset-0 bg-gradient-to-br from-rose-500 to-red-700" />
            <CardContent className="relative p-5">
              <div className="flex items-center justify-between mb-3">
                <div className="p-2 rounded-lg bg-white/20 backdrop-blur">
                  <TrendingDown className="w-5 h-5 text-white" />
                </div>
                <Badge className="bg-slate-900/70 text-white border border-white/30 text-[10px] font-bold tracking-wider px-2 py-0.5">CONSOMMATION</Badge>
              </div>
              <div className="text-3xl font-bold text-white tabular-nums">
                {stats.total_credits_consommes?.toLocaleString('fr-FR') || 0}
              </div>
              <div className="text-xs text-rose-100 mt-1">Crédits Consommés · Total utilisé</div>
              <div className="mt-3 text-white/85" title="Évolution sur 7 jours">
                <Sparkline data={sparkSeries?.credits_consommes || []} color="#ffffff" width={260} height={34} ariaLabel="Crédits consommés sur 7 jours" />
              </div>
            </CardContent>
          </Card>

          <Card className="relative overflow-hidden border-0 shadow-lg group hover:shadow-xl transition-all">
            <div className="absolute inset-0 bg-gradient-to-br from-emerald-500 to-teal-700" />
            <CardContent className="relative p-5">
              <div className="flex items-center justify-between mb-3">
                <div className="p-2 rounded-lg bg-white/20 backdrop-blur">
                  <Users className="w-5 h-5 text-white" />
                </div>
                <Badge className="bg-slate-900/70 text-white border border-white/30 text-[10px] font-bold tracking-wider px-2 py-0.5">ACTIFS</Badge>
              </div>
              <div className="text-3xl font-bold text-white tabular-nums">
                {(stats.utilisateurs_avec_credits || 0).toLocaleString('fr-FR')}
              </div>
              <div className="text-xs text-emerald-100 mt-1">Utilisateurs · Avec crédits actifs</div>
              <div className="mt-3 text-white/85" title="Évolution sur 7 jours">
                <Sparkline data={sparkSeries?.utilisateurs_actifs || []} color="#ffffff" width={260} height={34} ariaLabel="Utilisateurs actifs sur 7 jours" />
              </div>
            </CardContent>
          </Card>

          <Card className="kpi-rise kpi-rise-3 relative overflow-hidden border-0 shadow-lg group hover:shadow-xl transition-all">
            <div className="absolute inset-0 bg-gradient-to-br from-purple-600 to-fuchsia-700" />
            <CardContent className="relative p-5">
              <div className="flex items-center justify-between mb-3">
                <div className="p-2 rounded-lg bg-white/20 backdrop-blur">
                  <Activity className="w-5 h-5 text-white" />
                </div>
                <Badge className="bg-slate-900/70 text-white border border-white/30 text-[10px] font-bold tracking-wider px-2 py-0.5">MOUVEMENTS</Badge>
              </div>
              <div className="text-3xl font-bold text-white tabular-nums">
                {stats.nb_transactions?.toLocaleString('fr-FR') || 0}
              </div>
              <div className="text-xs text-purple-100 mt-1">Transactions · Mouvements totaux</div>
              <div className="mt-3 text-white/85" title="Évolution sur 7 jours">
                <Sparkline data={sparkSeries?.transactions || []} color="#ffffff" width={260} height={34} ariaLabel="Transactions sur 7 jours" />
              </div>
            </CardContent>
          </Card>
    </div>
  );
}
